import React from "react";
import "../CSS/LoadingScreen.css";

const LoadingScreen = ({ message = "Loading..." }) => {
    return (
        <div className="loading-overlay">
            {/* Simple hourglass / spinner icon */}
            <svg
                className="loading-icon"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="#55C2C3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeDasharray="40 20"
                />
            </svg>

            <p className="loading-text">{message}</p>
        </div>
    );
};

export default LoadingScreen;
